import actions from '@/core/store/configuracao/tipo-modelo-documento/actions'
import mutations from '@/core/store/configuracao/tipo-modelo-documento/mutations'
import state from '@/core/store/configuracao/tipo-modelo-documento/state'
export default {
	actions,
	mutations,
	state,
}
